import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "@/lib/api";

export default function PublicFunnelEntry() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/public/funnels/${slug}`);
        nav(`/p/${data.first_slug}?fnl=${slug}&step=0`, { replace: true });
      } catch { setErr(true); }
    })();
  }, [slug, nav]);

  if (err) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-center px-6">
        <div className="vp-label mb-3">Funnel unavailable</div>
        <h1 className="font-display text-3xl font-bold">This funnel is not active or was removed.</h1>
      </div>
    );
  }
  return <div className="min-h-screen flex items-center justify-center text-[#4A4D57]">Loading…</div>;
}
